import I18n from "i18n-js";
import { fetch } from "../../../appContainer";
import {
  GET_INSTALLATIONS_LIST_IN_PROGRESS,
  GET_INSTALLATIONS_LIST_SUCCESS,
  GET_INSTALLATIONS_LIST_FAIL,
  IMPORT_INSTALLATIONS_IN_PROGRESS,
  IMPORT_INSTALLATIONS_SUCCESS,
  IMPORT_INSTALLATIONS_FAIL,
  IMPORT_COMPRESSORS_IN_PROGRESS,
  IMPORT_COMPRESSORS_SUCCESS,
  IMPORT_COMPRESSORS_FAIL,
  GET_INSTALLATIONS_FILTERS_IN_PROGRESS,
  GET_INSTALLATIONS_FILTERS_SUCCESS,
  GET_INSTALLATIONS_FILTERS_FAIL,
  GET_INSTALLATIONS_COUNT_IN_PROGRESS,
  GET_INSTALLATIONS_COUNT_SUCCESS,
  GET_INSTALLATIONS_COUNT_FAIL,
  GET_INSTALLATION_INFO_IN_PROGRESS,
  GET_INSTALLATION_INFO_FAIL,
  GET_INSTALLATION_INFO_SUCCESS,
  UPDATE_INSTALLATION_IN_PROGRESS,
  UPDATE_INSTALLATION_SUCCESS,
  UPDATE_INSTALLATION_FAIL,
} from "../constants";
import { extractHeaderAttribute } from "../../common/utils/headerUtils";
import { SUBMIT_FAIL, SUBMIT_SUCCESS } from "../../common/constants";
import { errorAlert, successAlert } from "../../common/actions/alertActions";

/**
 * Get installations list
 */
export function getInstallationsList(filters = {}) {
  return (dispatch) => {
    dispatch({ type: GET_INSTALLATIONS_LIST_IN_PROGRESS });

    fetch("api").getInstallationsList(
      filters,
      (list) => {
        dispatch({ type: GET_INSTALLATIONS_LIST_SUCCESS, payload: { list } });
      },
      () => dispatch({ type: GET_INSTALLATIONS_LIST_FAIL })
    );
  };
}

/**
 * Import installations
 */
export function importInstallations(tsv) {
  return (dispatch) => {
    dispatch({ type: IMPORT_INSTALLATIONS_IN_PROGRESS });

    fetch("api").importInstallations(
      tsv,
      (tsvReportContent, response) => {
        const message = I18n.t("alerts.import:installations.success");
        const tsvReport = tsvReportContent && {
          name: extractHeaderAttribute(
            response.headers,
            "Content-Disposition",
            "filename"
          ),
          content: tsvReportContent,
        };

        dispatch({ type: SUBMIT_SUCCESS, payload: { message } });
        dispatch({
          type: IMPORT_INSTALLATIONS_SUCCESS,
          payload: { tsvReport },
        });
      },
      (content, response) => {
        let message = I18n.t("alerts.import:installations.fail");
        let error = true;

        // File too large:
        if (response.status === 413) {
          message = I18n.t("alerts.import:installations.file_too_large");
        }
        // Validation error:
        if ([422, 400].includes(response.status)) {
          error = content;
        }

        dispatch({ type: SUBMIT_FAIL, payload: { message } });
        dispatch({ type: IMPORT_INSTALLATIONS_FAIL, payload: { error } });
      }
    );
  };
}

/**
 * Import compressors
 */
export function importCompressors(tsv) {
  return (dispatch) => {
    dispatch({ type: IMPORT_COMPRESSORS_IN_PROGRESS });

    fetch("api").importCompressors(
      tsv,
      (tsvReportContent, response) => {
        const message = I18n.t("alerts.import:compressors.success");
        const tsvReport = tsvReportContent && {
          name: extractHeaderAttribute(
            response.headers,
            "Content-Disposition",
            "filename"
          ),
          content: tsvReportContent,
        };

        dispatch({ type: SUBMIT_SUCCESS, payload: { message } });
        dispatch({
          type: IMPORT_COMPRESSORS_SUCCESS,
          payload: { tsvReport },
        });
      },
      (content, response) => {
        let message = I18n.t("alerts.import:compressors.fail");
        let error = true;

        // File too large:
        if (response.status === 413) {
          message = I18n.t("alerts.import:compressors.file_too_large");
        }
        // Validation error:
        if ([422, 400].includes(response.status)) {
          error = content;
        }

        dispatch({ type: SUBMIT_FAIL, payload: { message } });
        dispatch({ type: IMPORT_COMPRESSORS_FAIL, payload: { error } });
      }
    );
  };
}

/**
 * Get installation info
 */
export function getInstallationInfo(uuid) {
  return (dispatch) => {
    dispatch({ type: GET_INSTALLATION_INFO_IN_PROGRESS });

    fetch("api").getInstallationInfo(
      uuid,
      (info) => {
        dispatch({ type: GET_INSTALLATION_INFO_SUCCESS, payload: { info } });
      },
      () => dispatch({ type: GET_INSTALLATION_INFO_FAIL })
    );
  };
}

/**
 * Get installation info
 */
export function getInstallationInfos(uuid) {
  return (dispatch) => {
    dispatch({ type: GET_INSTALLATION_INFO_IN_PROGRESS });

    fetch("api").getInstallationInfo(
      uuid,
      (info) => {
        dispatch({ type: GET_INSTALLATION_INFO_SUCCESS, payload: { info } });
      },
      () => dispatch({ type: GET_INSTALLATION_INFO_FAIL }),
    );
  };
}

/**
 * Update Installation
 */
export function putInstallation(uuid, payload) {
  return (dispatch) => {
    dispatch({ type: UPDATE_INSTALLATION_IN_PROGRESS });

    fetch("api").putInstallation(
      uuid,
      payload,
      () => {
        dispatch({ type: UPDATE_INSTALLATION_SUCCESS });
        dispatch(
          successAlert(
            I18n.t("pages.installations.actions.edit.alert.success"),
          ),
        );
      },
      (error) => {
        const errorMessage =
          error.status === 400
            ? I18n.t("pages.installations.actions.edit.error.not_unique")
            : "Something went wrong";
        dispatch({
          type: UPDATE_INSTALLATION_FAIL,
          payload: {
            message: errorMessage,
            code: error.status,
          },
        });
        dispatch(
          errorAlert(I18n.t("pages.installations.actions.edit.alert.error")),
        );
      },
    );
  };
}

export function getInstallationsFilters() {
  return (dispatch) => {
    dispatch({ type: GET_INSTALLATIONS_FILTERS_IN_PROGRESS });

    fetch("api").getInstallationsFilters(
      (filters) => {
        dispatch({ type: GET_INSTALLATIONS_FILTERS_SUCCESS, payload: { filters } });
      },
      () => dispatch({ type: GET_INSTALLATIONS_FILTERS_FAIL }),
    );
  };
}

export function getInstallationsCount(filters = {}) {
  return (dispatch) => {
    dispatch({ type: GET_INSTALLATIONS_COUNT_IN_PROGRESS });

    fetch("api").getInstallationsCount(
      filters,
      (count) => {
        dispatch({ type: GET_INSTALLATIONS_COUNT_SUCCESS, payload: { count } });
      },
      () => dispatch({ type: GET_INSTALLATIONS_COUNT_FAIL }),
    );
  };
}